import React, { useState } from "react";
import get from "lodash/get";
import { getPalateDiscoveryTestResult } from "../../../actions/palateDiscovery/test";
import { useQuery } from "react-query";
import { palateDiscoveryLinks } from "../../../utils/internalLinks";
import { Link } from "react-router-dom";
import PalateDiscoveryTest from "../../../containers/loggedIn/Feed/cards/PalateDiscoveryTest";

import { ReactComponent as InfoIconBlack } from '../../../assets/images/collaborations/pr/manage/status/infoBlack.svg';
import CommonPortal from "../../modals/common/CommonPortal";
const ProfileTaster = (props) => {
    const { isBlocked = false, profile, token , isSelf = false } = props;
    const {id} = profile;
    const [showPalateModal, setShowPalateModal] = useState(false);
    const hasTasterType = get(profile, "palate_discovery_taster_type", null);
    
    const { data } = useQuery({
        queryKey: ['palateDiscoveryTestResult'],
        queryFn: () => getPalateDiscoveryTestResult(token , id),
        enabled: (Boolean(token) && !!id && !!hasTasterType),
        keepPreviousData: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
         retry: false,
    });


    const togglePalateModal = () => {
        setShowPalateModal(!showPalateModal);
    }
    
     if(!data) return null;

     const hasReportURL = get(data , "report_url" , null);
     const hasSubmission = get(data , "assignment" , null);
     const assignmentId = get(data , "assignment.id" , false);


    return (
        <>
            {!isBlocked && hasTasterType &&
                <div className="profile-view__details__block__info palate-discovery__container" style={{marginTop: "16px"}} onClick={(e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                    }}>
                    <span className="palate-discovery__info cursor-pointer" onClick={(e)=>{
                         e.preventDefault();
                        e.stopPropagation();
                        togglePalateModal();
                    }}  style={{
                       "--tint-color": get(profile, "palate_discovery_taster_type.tint_color", "#171717")
                    }}>
                        <img src={get(profile, "palate_discovery_taster_type.icon", "")} alt="tester-icon" className="tester__icon" />
                        {get(profile, "palate_discovery_taster_type.value", "")}
                        <InfoIconBlack  />
                    </span>
                    {isSelf && <div className="palate-discovery__links">
                       {!!hasReportURL && <Link to={palateDiscoveryLinks.results(assignmentId)} className="link-item">
                            View Palate Report
                        </Link>}
                       {hasSubmission && <Link to={palateDiscoveryLinks.submission(get(data, "assignment.id", ""))} className="link-item">
                            View Test Submission
                        </Link>}
                    </div>}
                </div>
            }


            {
                !!showPalateModal && <CommonPortal><div onClick={(e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                    }}><PalateDiscoveryTest handleClose={togglePalateModal} assignmentInfoFromFeed={data} isModal  /></div></CommonPortal>
            }
        </>
    )

}



export default ProfileTaster